module.exports = __webpack_public_path__ + "static/media/0_2019_04_27.d8b9bb7f.jpg";